export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
export const AUTH_API_BASE_URL = process.env.REACT_APP_AUTH_API_URL || 'http://localhost:18082/api';

export const API_CONFIG = {
  baseURL: `${API_BASE_URL}/api/v1`,
  timeout: 10000,
} as const;
